import { type RefObject, useCallback, useEffect, useRef, useState } from "react";
import { useIsCalendarView } from "src/website-apps/shared/hooks/useIsCalendarView";

interface Result {
  stickyContainerRef: RefObject<HTMLDivElement>;
  isContainerStuck: boolean;
  canParticipateStickyCalendar: () => boolean;
}

export const useStickyCalendarEventListener = (): Result => {
  const stickyContainerRef = useRef<HTMLDivElement>(null);
  const [isContainerStuck, setIsContainerStuck] = useState(false);
  const isContainerStuckRef = useRef(false);
  const { isOnCalendarView } = useIsCalendarView();

  const canParticipateStickyCalendar = useCallback(() => isOnCalendarView, [isOnCalendarView]);

  useEffect(() => {
    const handleScroll = () => {
      if (!stickyContainerRef.current) return;
      const next = stickyContainerRef.current.getBoundingClientRect().top <= 0;
      if (next !== isContainerStuckRef.current) {
        isContainerStuckRef.current = next;
        setIsContainerStuck(next);
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return { stickyContainerRef, isContainerStuck, canParticipateStickyCalendar };
};
